import { WorkerChannel } from '@halo/utils/WorkerChannel';

const channel = new WorkerChannel(
  new Worker(new URL('./msg-file-cache.worker.ts', import.meta.url), { type: 'module' })
);

export function clearFileCache() {
  return channel.request('clear');
}

export function deleteFileCache(ids: string[]) {
  return channel.request('delete', {
    ids,
  });
}

export function getTotalFileCacheSize() {
  return channel.request<number>('totalSize');
}

export function getCachedFile(cli_msg_id: string) {
  return channel.request<File>('getFile', {
    cli_msg_id,
  });
}

export function setFileCache(cli_msg_id: string, file: File) {
  return channel.request('setFile', {
    cli_msg_id,
    file,
  });
}
